import React from "react";
import { ImCross } from "react-icons/im";
import { FaHandshake } from "react-icons/fa";
import WhatsAppQRCode from "../../images/whatsapp.png";
import { RiDeleteBack2Fill } from "react-icons/ri";
import { CustomizedSnackbars } from "../../MUI/MuiComponent";

export const WhatsApp = ({
  isWhatsAppQRCodeOpen,
  setisWhatsAppQRCodeOpen,
  isClicked,
  setIsClicked,
}) => {
  return (
    <div
      className={`${
        isWhatsAppQRCodeOpen
          ? "whatsapp-QR-code-container active-whatsapp-QR-code-container"
          : "whatsapp-QR-code-container"
      }`}
    >
      <div className="footer-whatsapp-qr-image-section">
        <img
          src={WhatsAppQRCode}
          alt="WhatsAppQRCode"
          className="whats-app-qr-code-image"
        />
        <p className="QR-first-p">
          Scan this code using the WhatsApp camera to get my number and call me
        </p>
        <p className="spna-QR">Or</p>
        <p className="QR-second-p">for using later</p>
        <div className="flex-center-qr-btns">
          <CustomizedSnackbars
            btnText="Download"
            downloadImg={WhatsAppQRCode}
            downloadNoti="WhatsApp QR code is downlaoding...."
          />
        </div>
        <button
          onClick={() => {
            setisWhatsAppQRCodeOpen(false);
            setIsClicked(false);
          }}
          className="QR-CODE-BTN-CLOSE whatsapp-cross-btn"
        >
          <ImCross />
        </button>
      </div>
      <div className={`model-message ${isClicked && "active-model-message"}`}>
        <h2>
          <FaHandshake />
        </h2>
        <p className="moderl-p-warning">
          Before calling- please make sure, you have an urgent need. Thanks for
          understanding & your cooperation.
        </p>
        <button onClick={() => setIsClicked(false)} className="fiDelete-alert">
          <RiDeleteBack2Fill />
        </button>
      </div>
    </div>
  );
};
